export const removePhoneNumberFormat = (phoneNumber) => {
  if (!phoneNumber) return "";
  return phoneNumber.replace("+81", "0").replace(/\s+/g, "");
};

// urlが有効な形式かどうかを判定する
export const isValidUrl = (
  url, // string
) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};
